import { render, staticRenderFns } from "./OverviewsImage.vue?vue&type=template&id=e8f7dd1c&"
import script from "./OverviewsImage.vue?vue&type=script&lang=js&"
export * from "./OverviewsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports